import React from "react";
import defaultImagetoSrcset from "lib/default_image_to_srcset.js";
import { v4 as uuidv4 } from "uuid";
const CardArt = ({ image }) => {
  // console.log("CardArt image", image);
  // https://mobx.js.org/configuration.html#limitations-without-proxy-support
  // image can be array, string, hashy object wrapped in proxy from mobx
  // slice for string and array, fails for {artist_name:  "", url: ""}
  try {
    if (typeof image.slice != "undefined") {
      image = image.slice();
    }
  } catch (e) {
    console.log("CardArt error", e);
  }
  return Array.isArray(image) ? (
    image.length == 4 ? (
      typeof image[0] == "string" ? (
        image.map((url) => {
          return (
            <img
              className="twobytwo"
              loading="lazy"
              src={url}
              key={uuidv4()}
              srcSet={defaultImagetoSrcset(url)}
            />
          );
        })
      ) : (
        image.map(({ url, artist_name = null, srcset = null }) => {
          //console.log(url, artist_name, srcset);
          return (
            <img
              alt={artist_name}
              className="twobytwo"
              key={uuidv4()}
              loading="lazy"
              src={url}
              srcSet={srcset || defaultImagetoSrcset(url)}
            />
          );
        })
      )
    ) : typeof image[0] == "string" ? (
      <img
        key={uuidv4()}
        className="w-100"
        loading="lazy"
        src={image[0]}
        srcSet={defaultImagetoSrcset(image[0])}
      />
    ) : (
      <img
        key={uuidv4()}
        alt={image[0].artist_name || null}
        className="w-100"
        loading="lazy"
        src={image[0].url}
        srcSet={defaultImagetoSrcset(image[0].url)}
      />
    )
  ) : typeof image == "string" ? (
    <img
      key={uuidv4()}
      className="w-100"
      loading="lazy"
      src={image}
      srcSet={defaultImagetoSrcset(image)}
    />
  ) : (
    <img
      key={uuidv4()}
      alt={image.artist_name || null}
      className="w-100"
      loading="lazy"
      src={image.url}
      srcSet={defaultImagetoSrcset(image.url)}
    />
  );
};

export default CardArt;
